import React from 'react'

import Text from '@common/components/Text'
import { ToastAction } from '@common/contexts/toastContext'
import spacings from '@common/styles/spacings'
import flexbox from '@common/styles/utils/flexbox'
import useHover, { AnimatedPressable } from '@web/hooks/useHover'

interface Props extends ToastAction {
  testID?: string
}

/**
 * Inline toast affordance ("Retry"). A pressable Text rather than Button —
 * Button is a full-sized control and reads far too heavy inside the card.
 */
const ToastActionLink = ({ text, onPress, testID }: Props) => {
  const [bindAnim, animStyle] = useHover({ preset: 'opacityInverted' })

  return (
    <AnimatedPressable
      {...bindAnim}
      testID={testID}
      style={[flexbox.alignSelfStart, spacings.mtMi, animStyle]}
      onPress={onPress}
    >
      <Text fontSize={13} weight="semiBold" appearance="linkText">
        {text}
      </Text>
    </AnimatedPressable>
  )
}

export default ToastActionLink
